import React, { useEffect, useState } from 'react';

type AgentationComponent = React.ComponentType<{ endpoint?: undefined; }>;

/**
 * 非 release 环境按需加载 Agentation，避免生产首包引入开发标注工具。
 */
export default function AgentationDevtools() {
  const [Agentation, setAgentation] = useState<AgentationComponent | null>(null);

  useEffect(() => {
    if (process.env.NEXT_PUBLIC_ENVIRONMENT === 'release') return undefined;

    let cancelled = false;
    import('agentation').then((mod) => {
      if (!cancelled) {
        setAgentation(() => mod.Agentation as AgentationComponent);
      }
    }).catch(() => undefined);

    return () => {
      cancelled = true;
    };
  }, []);

  if (!Agentation) return null;

  return <Agentation endpoint={undefined} />;
}
